import React from 'react';
import { useTranslation } from "react-i18next";

const TankLevelGraph = (props) => {
	const { level } = props;
	const { t } = useTranslation();

	const percentage = (level) ? Math.round((parseFloat(level) * 100)) : null;

	let stylesAttribute = { height:`${percentage}%` };
	if(!percentage || percentage <= 8){
		stylesAttribute.backgroundColor = 'transparent';
		stylesAttribute.height = '100%';
	}
	else if(percentage <= 25){ stylesAttribute.backgroundColor = '#EE1B21'; }
	else if(percentage <= 49){ stylesAttribute.backgroundColor = '#F2994A'; }

	return (
		<div className="tank__level">
			<div className="tank__level__current" style={{...stylesAttribute}}>
					{ (!percentage || percentage <= 8) ? (
						<strong className="tank__level__label" style={{color:'#EE1B21'}}>
							<span className="tank__level__label__icon"><i className="fas fa-exclamation-triangle"></i></span><br/>
							{ !percentage ? (
								<span dangerouslySetInnerHTML={{__html: t('tanks.details.level.noresult', {interpolation: {escapeValue: false}})}} />
							) : (
								<span>{ percentage }%</span>
							)}

						</strong>
					) : (
						<strong className="tank__level__label">
							<span>{ percentage }%</span>
						</strong>
					) }
			</div>
		</div>
	);
};

export default TankLevelGraph;
